var render = function render(){var _vm=this,_c=_vm._self._c;return _c('roles',{staticClass:"mt-6 ml-6",attrs:{"page":_vm.page,"items-per-page":_vm.itemsPerPage,"search":_vm.search,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"type":_vm.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }